import { $http } from "@/assets/js/appFunc";

export const actPluginList = () => {
    const req = {
        type: "GET",
        url: "/engine/api/plugins"
    };

    return $http(req, true);
};
export const actImportPlugin = (context, data) => {
    const req = {
        type: "POST",
        url: "/engine/api/plugins",
        data,
        noNotify: true
    };

    return $http(req, true);
};
